var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGiftOpen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "23px",
    viewBox: "0 0 20.0 23.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,812 L0,812 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1210466,0 L16.1210466,9.45483937 C16.1207156,9.80168428 15.8397128,10.0828215 15.492868,10.0833185 L0.628479166,10.0833185 C0.281517065,10.0829871 0.000331387143,9.80180147 0,9.45483937 L0,0 L16.1210466,0 Z M10.080786,0.00237378969 L9.48078597,0.00237378969 L9.48078597,10.0823738 L10.080786,10.0823738 L10.080786,0.00237378969 Z M6.65078597,0.00237378969 L6.05078597,0.00237378969 L6.05078597,10.0823738 L6.65078597,10.0823738 L6.65078597,0.00237378969 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6731111,0 C19.7636281,0 19.837219,0.0732904465 19.837219,0.163807339 L19.837219,2.48716647 C19.837219,2.57768337 19.7636281,2.65097381 19.6731111,2.65097381 L0.164107903,2.65097381 C0.0735908586,2.65097381 0,2.57768337 0,2.48716647 L0,0.163807339 C0,0.0732904465 0.0735908586,0 0.164107903,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.827617356,0.235907448 C1.20278893,-0.0786358161 1.74957712,-0.0786358161 2.12474869,0.235907448 L5.71928031,3.24955717 C6.07616892,3.54877203 6.12292274,4.08064899 5.82370788,4.43753761 C5.79201963,4.47533377 5.75707647,4.51027693 5.71928031,4.54196518 C5.62080089,4.62453017 5.50911982,4.6863667 5.39047246,4.72597232 L5.3725229,4.73087311 L5.36128815,4.75197239 L5.29760214,4.83853227 C5.26591389,4.87632843 5.23097074,4.91127159 5.19317457,4.94295984 L1.59864296,7.95660956 C1.22347138,8.27115282 0.67668319,8.27115282 0.301511617,7.95660956 C-0.0553769996,7.6573947 -0.102130815,7.12551774 0.197084046,6.76862912 C0.228772293,6.73083296 0.263715451,6.6958898 0.301511617,6.66420155 L3.6275229,3.87487311 L0.827617356,1.52831546 C0.500469457,1.25403517 0.43392094,0.784254086 0.655573013,0.432966854 L0.723189785,0.340335019 C0.754878031,0.302538853 0.78982119,0.267595695 0.827617356,0.235907448 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64.0 -495.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.0 85.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 402.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.070141985622014 8.701632053995105)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.089072042650514 12.175994156313436)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16.1210466,0 16.1210466,10.0833185 0,10.0833185 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.348877145181177e-14 10.644904504665082) rotate(-20.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-9.09494702e-13,0 19.837219,0 19.837219,2.65097381 -9.09494702e-13,2.65097381 -9.09494702e-13,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.745712971430706 2.1316282072803006e-14) rotate(70.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-2.27373675e-13,0 6.02079193,0 6.02079193,8.19251701 -2.27373675e-13,8.19251701 -2.27373675e-13,0",
    stroke: "none",
    fill: "#FFFFFF"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGiftOpen);
export default __webpack_public_path__ + "static/media/icGiftOpen.73264e01461083715226b2d11e40d353.svg";
export { ForwardRef as ReactComponent };